import Spin from "antd/es/spin";
import Tooltip from "antd/es/tooltip";
import { IconWrapper } from "features/trades/common/styles";
import { LanguageNameSpaces, TradeData } from "@shared/types";
import React from "react";
import ShareAltOutlined from "@ant-design/icons/ShareAltOutlined";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";
import { useShareResultData } from "@shared/features/trades/common/hooks";
import AnimatedShareIcon from "common/Animations/AnimatedShareIcon";
import styled from "styled-components";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { Share2 } from "lucide-react";
import LookIcon from "common/Icons/LookIcon";
import { NEW_LOOK_ICON_STROKE } from "common/NewLook";

interface ShareTradeButtonProps {
  tradeData: TradeData;
}

const ShareTradeButton = ({ tradeData }: ShareTradeButtonProps) => {
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADES);
  const {
    isInvalid,
    showSpin,
    showAnimation,
    onShareClick,
    shareTradeImageLoading,
  } = useShareResultData(tradeData);

  return (
    <Tooltip
      title={t("drawer.share_results")}
      trigger={isMobile ? [] : ["hover"]}
    >
      <IconWrapper>
        {showSpin ? (
          <StyledSpin spinning={shareTradeImageLoading} size="small" />
        ) : showAnimation ? (
          <AnimatedShareIcon onClick={() => onShareClick()} />
        ) : (
          <LookIcon
            classic={
              <StyledShareAltOutlined
                disabled={isInvalid}
                onClick={() => onShareClick()}
              />
            }
            newLook={
              <NewLookShareIcon
                size={17}
                strokeWidth={NEW_LOOK_ICON_STROKE}
                aria-disabled={isInvalid}
                onClick={() => onShareClick()}
              />
            }
          />
        )}
      </IconWrapper>
    </Tooltip>
  );
};

export default ShareTradeButton;

const StyledSpin = styled(Spin)`
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledShareAltOutlined = styled(ShareAltOutlined)`
  font-size: 20px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`;
const NewLookShareIcon = styled(Share2)`
  cursor: pointer;
  color: ${(p) => p.theme.colors.secondaryText};
  &[aria-disabled="true"] {
    opacity: 0.4;
  }
`;
